/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ProjectGetByIdV2 } from '../models/project-get-by-id-v-2';
import { projectsControllerCreateProject } from '../fn/projects-controller/projects-controller-create-project';
import { ProjectsControllerCreateProject$Params } from '../fn/projects-controller/projects-controller-create-project';
import { projectsControllerDeleteProject } from '../fn/projects-controller/projects-controller-delete-project';
import { ProjectsControllerDeleteProject$Params } from '../fn/projects-controller/projects-controller-delete-project';
import { projectsControllerGetProject } from '../fn/projects-controller/projects-controller-get-project';
import { ProjectsControllerGetProject$Params } from '../fn/projects-controller/projects-controller-get-project';
import { projectsControllerGetProjectByToken } from '../fn/projects-controller/projects-controller-get-project-by-token';
import { ProjectsControllerGetProjectByToken$Params } from '../fn/projects-controller/projects-controller-get-project-by-token';
import { projectsControllerGetProjects } from '../fn/projects-controller/projects-controller-get-projects';
import { ProjectsControllerGetProjects$Params } from '../fn/projects-controller/projects-controller-get-projects';
import { projectsControllerPatchProject } from '../fn/projects-controller/projects-controller-patch-project';
import { ProjectsControllerPatchProject$Params } from '../fn/projects-controller/projects-controller-patch-project';
import { projectsControllerRecalculateProject } from '../fn/projects-controller/projects-controller-recalculate-project';
import { ProjectsControllerRecalculateProject$Params } from '../fn/projects-controller/projects-controller-recalculate-project';


/**
 * API resource for projects manipulation.
 */
@Injectable({ providedIn: 'root' })
export class ProjectsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsControllerGetProjects()` */
  static readonly ProjectsControllerGetProjectsPath = '/planning-projects/v2-preview/projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerGetProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerGetProjects$Response(params?: ProjectsControllerGetProjects$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProjectGetByIdV2>>> {
    return projectsControllerGetProjects(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerGetProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerGetProjects(params?: ProjectsControllerGetProjects$Params, context?: HttpContext): Observable<Array<ProjectGetByIdV2>> {
    return this.projectsControllerGetProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProjectGetByIdV2>>): Array<ProjectGetByIdV2> => r.body)
    );
  }

  /** Path part for operation `projectsControllerCreateProject()` */
  static readonly ProjectsControllerCreateProjectPath = '/planning-projects/v2-preview/projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerCreateProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerCreateProject$Response(params?: ProjectsControllerCreateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectGetByIdV2>> {
    return projectsControllerCreateProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerCreateProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerCreateProject(params?: ProjectsControllerCreateProject$Params, context?: HttpContext): Observable<ProjectGetByIdV2> {
    return this.projectsControllerCreateProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectGetByIdV2>): ProjectGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `projectsControllerGetProjectByToken()` */
  static readonly ProjectsControllerGetProjectByTokenPath = '/planning-projects/v2-preview/projects/token/{token}';

  /**
   * Resolves a project by its opaque reopen-link token. Returns 404 when the token is unknown.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerGetProjectByToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerGetProjectByToken$Response(params: ProjectsControllerGetProjectByToken$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectGetByIdV2>> {
    return projectsControllerGetProjectByToken(this.http, this.rootUrl, params, context);
  }

  /**
   * Resolves a project by its opaque reopen-link token. Returns 404 when the token is unknown.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerGetProjectByToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerGetProjectByToken(params: ProjectsControllerGetProjectByToken$Params, context?: HttpContext): Observable<ProjectGetByIdV2> {
    return this.projectsControllerGetProjectByToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectGetByIdV2>): ProjectGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `projectsControllerGetProject()` */
  static readonly ProjectsControllerGetProjectPath = '/planning-projects/v2-preview/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerGetProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerGetProject$Response(params: ProjectsControllerGetProject$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectGetByIdV2>> {
    return projectsControllerGetProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerGetProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerGetProject(params: ProjectsControllerGetProject$Params, context?: HttpContext): Observable<ProjectGetByIdV2> {
    return this.projectsControllerGetProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectGetByIdV2>): ProjectGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `projectsControllerDeleteProject()` */
  static readonly ProjectsControllerDeleteProjectPath = '/planning-projects/v2-preview/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerDeleteProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerDeleteProject$Response(params: ProjectsControllerDeleteProject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return projectsControllerDeleteProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerDeleteProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerDeleteProject(params: ProjectsControllerDeleteProject$Params, context?: HttpContext): Observable<void> {
    return this.projectsControllerDeleteProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectsControllerPatchProject()` */
  static readonly ProjectsControllerPatchProjectPath = '/planning-projects/v2-preview/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerPatchProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerPatchProject$Response(params: ProjectsControllerPatchProject$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectGetByIdV2>> {
    return projectsControllerPatchProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerPatchProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsControllerPatchProject(params: ProjectsControllerPatchProject$Params, context?: HttpContext): Observable<ProjectGetByIdV2> {
    return this.projectsControllerPatchProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectGetByIdV2>): ProjectGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `projectsControllerRecalculateProject()` */
  static readonly ProjectsControllerRecalculateProjectPath = '/planning-projects/v2-preview/projects/{id}/recalculate';

  /**
   * Recalculates current installation costs and updates the project in place.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsControllerRecalculateProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerRecalculateProject$Response(params: ProjectsControllerRecalculateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return projectsControllerRecalculateProject(this.http, this.rootUrl, params, context);
  }

  /**
   * Recalculates current installation costs and updates the project in place.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsControllerRecalculateProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsControllerRecalculateProject(params: ProjectsControllerRecalculateProject$Params, context?: HttpContext): Observable<void> {
    return this.projectsControllerRecalculateProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
